import { gql } from '@apollo/client';
import changeDateRequestFragment from './changeDateRequestFragment';

const changeDateRequestEventFragment = gql`
  fragment ChangeDateRequestEventFields on AppraiserEvent {
    Id
    StartDate
    EndDate
    AppraiserEventChangeDateRequest {
      ...ChangeDateRequestFields
    }
  }

  ${changeDateRequestFragment}
`;

export default changeDateRequestEventFragment;
